var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRadiator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "119.09 96.03 468.25 368.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(5.6 0 0 5.6 70 3.979e-14)",
    d: "m39.105 76.646c0 3.4319-2.7748 6.2047-6.2109 6.2047-3.4263 0-6.1998-2.7727-6.1998-6.2047v-53.259c0-3.4263 2.7741-6.1998 6.1998-6.1998 3.4361 0 6.2109 2.7741 6.2109 6.1998zm0 0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2551
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m288.99 429.22c0 19.219-15.539 34.746-34.781 34.746-19.188 0-34.719-15.527-34.719-34.746v-298.25c0-19.188 15.535-34.938 34.719-34.938 19.242 0 34.781 15.754 34.781 34.938z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(5.6 0 0 5.6 70 3.979e-14)",
    d: "m56.855 76.646c0 3.4319-2.7727 6.2047-6.2088 6.2047-3.4263 0-6.2061-2.7727-6.2061-6.2047v-53.259c0-3.4263 2.7797-6.1998 6.2061-6.1998 3.4361 0 6.2088 2.7741 6.2088 6.1998zm0 0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2551
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m388.39 429.22c0 19.219-15.527 34.746-34.77 34.746-19.188 0-34.754-15.527-34.754-34.746v-298.25c0-19.188 15.566-34.938 34.754-34.938 19.242 0 34.77 15.754 34.77 34.938z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(5.6 0 0 5.6 70 3.979e-14)",
    d: "m92.359 76.646c0 3.4319-2.7748 6.2047-6.2047 6.2047-3.4319 0-6.2109-2.7727-6.2109-6.2047l-6.98e-4 -53.259c0-3.4263 2.779-6.1998 6.2109-6.1998 3.4298 0 6.2047 2.7741 6.2047 6.1998zm0 0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2551
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m587.21 429.22c0 19.219-15.539 34.746-34.746 34.746-19.219 0-34.781-15.527-34.781-34.746l-0.003906-298.25c0-19.188 15.562-34.938 34.781-34.938 19.207 0 34.746 15.754 34.746 34.938z",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(5.6 0 0 5.6 70 3.979e-14)",
    d: "m74.607 76.646c0 3.4319-2.7748 6.2047-6.2109 6.2047-3.4263 0-6.2047-2.7727-6.2047-6.2047l-6.97e-4 -53.259c0-3.4263 2.779-6.1998 6.2047-6.1998 3.4361 0 6.2109 2.7741 6.2109 6.1998zm0 0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2551
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m487.8 429.22c0 19.219-15.539 34.746-34.781 34.746-19.188 0-34.746-15.527-34.746-34.746l-0.003907-298.25c0-19.188 15.562-34.938 34.746-34.938 19.242 0 34.781 15.754 34.781 34.938z",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m198.5 137.01v59.598l-79.41-14.941z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m198.5 137.01-79.41 44.656v-29.715z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadiator);
export default __webpack_public_path__ + "static/media/icon-radiator.0cbed2f672ee5baf77bff455b590c074.svg";
export { ForwardRef as ReactComponent };